import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/cn.ts'

export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span className="inline-flex size-9 items-center justify-center rounded-sm bg-primary text-on-primary">
        <Sparkles className="size-5" aria-hidden="true" />
      </span>
      {compact ? null : (
        <span className="text-title-lg font-medium text-on-surface">
          YT Clip <span className="text-primary">AI</span>
        </span>
      )}
    </span>
  )
}
